module.exports = __webpack_public_path__ + "static/media/01_controller_switches.8fd40fb3.jpg";